import React, { Component } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { Button, Row, Input } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import { USER_QUERY_CREDIT_URL } from '../../actions/url';
import ReactDataGrid from "react-data-grid";
import {Data} from "react-data-grid-addons";

const propTypes = {
  onCloseClicked: PropTypes.func.isRequired,
  selectedUserId: PropTypes.string,
  selectedMobileUserId: PropTypes.string.isRequired,
};

class CreditDetailModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rows: [],
    };
    this.getCreditList(props.selectedMobileUserId);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.selectedMobileUserId === this.props.selectedMobileUserId) {
      return;
    }
    this.setState({ rows: [] });
    this.getCreditList(nextProps.selectedMobileUserId);
  }

  getCreditList = (id) => {
    const data = new FormData();
    data.append('pk', id);
    axios.post(
      USER_QUERY_CREDIT_URL,
      data,
      {
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
      },
    ).then((response) => {
      if (response.status !== 200) {
        return;
      }
      this.setState({
        rows: JSON.parse(response.data).map((item, index) => ({
          ...item,
          id: index,
        })),
      });
    })
      .catch(() => {
        alert('Could not edit credit, please try again!');
      });
  };

  handleGridSort = (sortColumn, sortDirection) => {
    this.setState({ sortColumn, sortDirection });
  };

  handleFilterChange = (filter) => {
    const newFilters = Object.assign({}, this.state.filters);
    if (filter.filterTerm) {
      newFilters[filter.column.key] = filter;
    } else {
      delete newFilters[filter.column.key];
    }
    this.setState({ filters: newFilters });
  };

  rowGetter = (rowIdx) => {
    const rows = this.getRows();
    return rows[rowIdx];
  };

  getRows = () => Data.Selectors.getRows(this.state);

  getSize = () => this.getRows().length;

  render() {
    const columns = [
      {
        key: 'creater',
        name: 'Creater',
        resizable: true,
        sortable: true,
        filterable: true,
      },
      {
        key: 'amount',
        name: 'Amount',
        resizable: true,
        sortable: true,
        filterable: true,
      },
      {
        key: 'reason',
        name: 'Reason',
        resizable: true,
        sortable: true,
        filterable: true,
      },
      {
        key: 'create_time',
        name: <Translate value="create_time" />,
        resizable: true,
        sortable: true,
        filterable: true,
      },
    ];

    return (
      <div>
        <div
          id="MobileUserTable-dataGrid1"
          style={{ marginTop: "50px", zIndex: 0 }}
        >
          <ReactDataGrid
            rowKey="id"
            onGridSort={this.handleGridSort}
            headerRowHeight={50}
            rowHeight={30}
            onAddFilter={this.handleFilterChange}
            columns={columns}
            minHeight={560}
            rowGetter={this.rowGetter}
            rowsCount={this.getSize()}
          />
        </div>
      </div>
    );
  }
}

CreditDetailModal.propTypes = propTypes;
export default CreditDetailModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Settings/CreditDetailModal.jsx